import { CONN_STATUS_LABELS, fmtDate } from "./constants";
import { StatusCard } from "./StatusCard";

export function StatusCards({ arch, isConnected }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-6 gap-3" data-testid="jt-status-cards">
      <StatusCard label="Stato connessione" value={CONN_STATUS_LABELS[arch?.connection_status] || arch?.stato || "NON_COLLEGATO"}
        tone={isConnected ? "green" : "slate"} testid="jt-conn-status" />
      <StatusCard label="API Version" value={arch?.api_version || "—"} tone="slate" testid="jt-api-version" />
      <StatusCard label="Ultimo sync OK" value={arch?.last_successful_sync ? fmtDate(arch.last_successful_sync) : "—"} tone="slate" testid="jt-last-sync" />
      <StatusCard label="Frequenza" value={arch?.sync_frequency || "MANUAL"} tone="slate" testid="jt-frequency" />
      <StatusCard label="Mapping rules" value={arch?.mapping_rules ?? "—"} tone="slate" testid="jt-mapping-count" />
      <StatusCard label="Conflitti aperti" value={arch?.conflicts_open ?? "—"} tone={arch?.conflicts_open ? "red" : "slate"} testid="jt-conflicts-count" />
    </div>
  );
}
